import { render, staticRenderFns } from "./CreateNFT.vue?vue&type=template&id=216d9d92&scoped=true&"
import script from "./CreateNFT.vue?vue&type=script&lang=js&"
export * from "./CreateNFT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216d9d92",
  null
  
)

export default component.exports